export default __webpack_public_path__ + "static/media/Sand Split.db8068bf.png";